import React from "react";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackButton = ({ sx }) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate(-1)}
      sx={{
        borderRadius: "8px",
        textTransform: "none",
        fontWeight: "bold",
        py: 0.5,
        px: 2,
        mb: 2,
        ...sx,
      }}
    >
      Back
    </Button>
  );
};

export default BackButton;
